import { toast } from 'react-toastify'
import { getErrorMessage } from '../../helpers'
import { apiSlice } from '../api/apiSlice'
import { OriginResponse } from './origin.type'
import { type ErrorType } from '../shared/shared.type'

export const originApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    updateOrigin: builder.mutation<
      OriginResponse,
      { body: { name: string }; id: string }
    >({
      query: (payload) => ({
        url: `v1/origin/${payload.id}`,
        method: 'PATCH',
        body: payload.body,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'ORIGIN', id: arg.id },
        { type: 'ORIGIN', id: 'LIST' },
        { type: 'USER', id: 'LIST' },
      ],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled
          toast.success('Origin updated successfully.')
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    addOrigin: builder.mutation<OriginResponse, { name: string }>({
      query: (payload) => ({
        url: `v1/origin`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'ORIGIN', id: 'LIST' }],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          toast.success(data.message)
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    getAllOrigins: builder.query<OriginResponse, any>({
      query: (args) => ({
        url: `v1/origin`,
        method: 'GET',
        params: {
          ...args,
        },
      }),
      providesTags: [{ type: 'ORIGIN', id: 'LIST' }],
    }),
    deleteOrigin: builder.mutation<OriginResponse, string>({
      query: (id) => ({
        url: `v1/origin/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'ORIGIN', id },
        { type: 'ORIGIN', id: 'LIST' },
        { type: 'USER', id: 'LIST' },
      ],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled
          toast.success('Origin deleted successfully.')
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
  }),
})

export const {
  useUpdateOriginMutation,
  useAddOriginMutation,
  useGetAllOriginsQuery,
  useDeleteOriginMutation,
} = originApiSlice
